import { CustomerDataFieldConfigurations, CustomerDataFields } from "../../interfaces/CustomerData/CustomerData";

export const customerDataFieldConfigurations: CustomerDataFieldConfigurations = {
    [CustomerDataFields.FORMOFADDRESS]: {
        required: true
    },
    [CustomerDataFields.TITLE]: {
        required: false,
        maxLength: 30,
    },
    [CustomerDataFields.PRENAME]: {
        required: true,
        maxLength: 20,
    },
    [CustomerDataFields.SURNAME]: {
        required: true,
        maxLength: 22,
    },
    [CustomerDataFields.PHONENUMBER]: {
        required: true,
        validation: 'tel',
        maxLength: 29,
    },
    [CustomerDataFields.MAIL]: {
        required: true,
        validation: 'email',
        maxLength: 50,
    },
    [CustomerDataFields.ISBILLINGMAIL]: {
        required: true,
    },
    [CustomerDataFields.LOGIN]: {
        required: true,
        maxLength: 50,
    },
    [CustomerDataFields.COMPANYNAME]: {
        required: true,
        maxLength: 50,
    },
    [CustomerDataFields.TRADE]: {
        required: true
    },
    [CustomerDataFields.PLZ]: {
        required: true,
        validation: 'plz',
        maxLength: 5,
    },
    [CustomerDataFields.CITY]: {
        required: true,
        maxLength: 50,
    },
    [CustomerDataFields.STREET]: {
        required: true,
        validation: 'street',
        maxLength: 50,
    },
    [CustomerDataFields.STREETNUMBER]: {
        required: true,
        maxLength: 10,
    },
    [CustomerDataFields.BILLINGMAIL]: {
        required: true,
        validation: 'email',
        maxLength: 50,
    },
    [CustomerDataFields.HOMEPAGE]: {
        required: false,
        maxLength: 80,
    },
    [CustomerDataFields.POSITION]: {
        required: false
    },
    [CustomerDataFields.SOLICITOR]: {
        required: false
    },
    [CustomerDataFields.INTERESTS]: {
        required: false
    },
    [CustomerDataFields.MEMBERSHIPS]: {
        required: false
    },
    [CustomerDataFields.PAYTYP]: {
        required: true
    },
    [CustomerDataFields.IBAN]: {
        required: true,
        validation: 'iban'
    },
    [CustomerDataFields.CONTACTNO]: {
        required: false
    },
    [CustomerDataFields.TRACKINGCONSENT]: {
        required: false
    },
};